import type { Node } from '@xyflow/react';
import { DEPTH_COLORS } from './treemap-constants';
import { hexToRgba } from './treemap-format';
import { TreemapNodeKind, type TreemapNodeData } from './treemap-types';

const SECTION_MINIMAP_FILL_ALPHA = 0.25;
const LEAF_MINIMAP_FILL_ALPHA = 0.6;

function getMinimapDepthColor(colorIndex: number): string {
  return DEPTH_COLORS[colorIndex % DEPTH_COLORS.length] ?? DEPTH_COLORS[0];
}

export function getTreemapMinimapNodeColor(node: Node<TreemapNodeData>): string {
  const colorIndex = typeof node.data?.colorIndex === 'number' ? node.data.colorIndex : 0;
  const color = getMinimapDepthColor(colorIndex);
  const alpha =
    node.data?.kind === TreemapNodeKind.Section
      ? SECTION_MINIMAP_FILL_ALPHA
      : LEAF_MINIMAP_FILL_ALPHA;

  return hexToRgba(color, alpha);
}
